module.exports = __webpack_public_path__ + "static/media/logo.e0db0e61.png";